import { HeadCell } from 'shell/components/shared/table/types';
import { ActValueDomainVM } from 'civil-status/view-models/act-value-domain-managment-list';
import { ValueDomainTableFiltersVM } from 'civil-status/view-models/act-value-domain';

export const headCells: HeadCell<ActValueDomainVM, keyof ActValueDomainVM>[] = [
  {
    id: 'value',
    label: 'Valore',
  },
  {
    id: 'valueAnsc',
    label: 'Valore ANSC',
  },
  {
    id: 'shortDescription',
    label: 'Descrizione breve',
  },
  {
    id: 'startValidityDate',
    label: 'Data inizio validità',
  },
  {
    id: 'endValidityDate',
    label: 'Data fine validità',
  },
  {
    id: 'displayOrderNumber',
    label: 'N. ordinamento',
  },
  {
    id: 'action',
    label: '',
  },
];

export const initialValuesFilterTable: ValueDomainTableFiltersVM = {
  orders: {},
  page: 0,
  rowsPerPage: 10,
};
